<p-overlayPanel #hoveroverlay [appendTo]="'body'" [baseZIndex]="100"
  [style]="{'max-width': '275px','margin-left': '-50px','word-break':'break-word'}">
  <div *ngFor="let info of this.hoverInfo">
    <b>{{info.title}}: </b> <span class="text-break">{{info.data}}</span>
  </div>
</p-overlayPanel>

<dialog-draggable-header>Add Reason</dialog-draggable-header>

<mat-dialog-content>
  <form class="container" [formGroup]="form">
    <div class="row">
      <mat-form-field class="col">
        <mat-label>Reason Code</mat-label>
        <mat-select formControlName="reasonCodeId">
          <mat-option *ngFor="let reasonCode of reasonCodes" [value]="reasonCode.id"
            (mouseenter)="handleHoverEnter($event, reasonCode)" (mouseleave)="handleHoverLeave($event)">
            {{reasonCode.reasonCode}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox class="col my-auto" formControlName="desFinish">Design Finish</mat-checkbox>
      <mat-checkbox class="col my-auto" formControlName="bldFinish">Build Finish</mat-checkbox>
    </div>
    <div class="row">
      <mat-form-field class="col-12">
        <mat-label for="rationale">Rationale</mat-label>
        <textarea class="bg-light" id="rationale" matInput formControlName="rationale" maxLength="325"></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
  <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="save()"
    (keydown.enter)="save()">Save</button>
  <button mat-raised-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>